// extracted by mini-css-extract-plugin
export default {"wrapper":"kw","noPadding":"lw","flavor_wrapper":"mw","flavor_button":"nw","vert":"ow","itemContent":"pw","itemName":"qw","blue":"rw","out_of_stock":"sw","newFlavorBadge":"tw","fullWidth":"uw","flavor_button_selected":"vw","black":"ww","attribute_wrapper":"xw","toggle_wrapper":"yw"};
    if(module.hot) {
      // 1711717533152
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  